import styled from 'styled-components'

export const Wrapper = styled.section`
  margin-top: 30px; /* stylelint-disable-line scales/space */
  background: ${({ theme }) => theme.colors.cherokee};
  padding: 15px 20px; /* stylelint-disable-line scales/space */
  border-radius: 4px;
  margin-bottom: 1em; /* stylelint-disable-line scales/space */
`

export const Title = styled.h1`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.nutmeg};
  margin: 0 0 8px;
  line-height: 1;
`
export const Description = styled.span`
  color: ${({ theme }) => theme.colors.chelseagem};
  font-size: 0.8125rem;
`
